<template>
	 <v-container>
		 <v-dialog title="填写学员状况" v-model="hideShow" width="500" persistent>
			<v-card>
				<v-card-title>
					<span>填写学员状况</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12">
							<v-textarea outlined label="学员学习情况" v-model="add.briefDesc"></v-textarea>       
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitAdd" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"create-situation",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			classStudent:{
				type:Object,
				default:null
			}
		},
		watch:{
			show(newVal,oldVal){
				this.hideShow = newVal;
				if (newVal){
					this.add.briefDesc = "";
				}
			},
			
		},
		data(){
			return {
				add: {
					briefDesc:"",
				},
				hideShow:this.show,
				
			}
		},
		mounted() {
			console.log("create-student-situation mounted");
		},
		methods:{
			
			submitAdd(){
				
				if (!this.add.briefDesc) {
					this.$noty.error('内容不能为空');
					return
				}
					
				// api
				const that = this;
				let url = `/edu/student/situation/create`;
				let postData = {...this.add};
				postData.classId = this.classStudent.classId;
				postData.studentId = this.classStudent.studentId;
				
				const contentText = this.add.briefDesc;
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");						
							this.$emit("success",contentText);	
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
				
			},
			cancel(){
				this.$emit("cancel","");
			}
		}
	}
	
</script>

<style>
</style>
